import type { QueryClient } from "@tanstack/react-query";

export default async function invalidateWishlistQueries(
  queryClient: QueryClient,
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["wishlist"] }),
    queryClient.invalidateQueries({ queryKey: ["wishlistItems"] }),
  ]);
}
